import { Typography } from '@material-ui/core';
import { Mail, Phone } from '@material-ui/icons';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { DescriptionItem } from '@superdispatch/ui-lab';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { LoadboardSubscriptionSettingsDTO } from './data/LoadboardUserSettingsDTO';
import { NotificationSettingContactsUpdatePhoneDesktop } from './NotificationSettingContactsUpdatePhoneDesktop';
import { NotificationSettingContactsUpdatePhoneMobile } from './NotificationSettingContactsUpdatePhoneMobile';

interface Props {
  type: 'carrier' | 'dispatcher';
  settings: LoadboardSubscriptionSettingsDTO;
}

export function NotificationSettingContacts({
  type,
  settings: userSettings,
}: Props) {
  const email =
    type === 'carrier' ? userSettings.carrier_email : userSettings.email;
  const phone_number =
    type === 'carrier'
      ? userSettings.carrier_phone_number
      : userSettings.phone_number;

  return (
    <Stack>
      <Typography color="textSecondary">Updates sent to:</Typography>

      <Columns collapseBelow="tablet" space="small">
        <Column>
          <Columns collapseBelow="tablet" space="small">
            <Column width="adaptive">
              <DescriptionItem
                icon={<Mail />}
                fallback="No Email"
                aria-label="email contact"
              >
                {email}
              </DescriptionItem>
            </Column>

            <Column width="adaptive">
              <DescriptionItem
                icon={<Phone />}
                fallback="No Phone"
                aria-label="phone contact"
              >
                {phone_number}
              </DescriptionItem>
            </Column>
          </Columns>
        </Column>

        <Column width="content">
          {MobileAppBridge.isInjected() ? (
            <NotificationSettingContactsUpdatePhoneMobile type={type} />
          ) : (
            <NotificationSettingContactsUpdatePhoneDesktop type={type} />
          )}
        </Column>
      </Columns>
    </Stack>
  );
}
